import React from "react";
import { observer } from "mobx-react";
import { THEME_SETTINGS } from "@theme-settings";
import { useRootAppStore } from "@hooks";

export const NotificationFavoritesButton = !THEME_SETTINGS.features
	.isFavoritesEnabled
	? () => null
	: observer(function NotificationFavoritesButton(props: {
			eventId: string;
		}) {
			const {
				notificationFavoritesStore: {
					shouldDisplayNotificationFavoriteButton,
					userFavoriteNotificationEventSet,
					toggleEventFavoriteStatus,
				},
			} = useRootAppStore();

			if (!shouldDisplayNotificationFavoriteButton) {
				return null;
			}

			const isFavorite = userFavoriteNotificationEventSet.has(
				props.eventId
			);

			const toggleFavorite = (e: React.MouseEvent<HTMLButtonElement>) => {
				e.preventDefault();
				e.stopPropagation();
				toggleEventFavoriteStatus(props.eventId);
			};

			return (
				<button
					className="at-actionNotif match__details__btn btn btn--square--reset btn--ghost"
					onClick={toggleFavorite}
				>
					{isFavorite ? (
						<i className="match__details__icon u-icon u-icon--xsml u-icon--bell-on" />
					) : (
						<i className="match__details__icon u-icon u-icon--xsml u-icon--bell-off" />
					)}
				</button>
			);
		});
